export const initUsersSettings = resp => {
  return {
    type: "INIT_USERS_SETTINGS"
  };
};

export const selectRole = role => {
  return {
    type: "SELECT_ROLE",
    role
  };
};

export const setRole = role => {
  return {
    type: "SET_ROLE",
    role
  };
};

export const setSelectedUsers = selectedUsers => {
  return {
    type: "SET_SELECTED_USERS",
    selectedUsers
  };
};

export const selectSearchWord = searchWord => {
  return {
    type: "SELECT_SEARCH_WORD",
    searchWord
  };
};

export const setAllowCreateDashboard = allowCreateDashboard => {
  return {
    type: "SET_ALLOW_CREATE_DASHBOARD",
    allowCreateDashboard
  };
};

export const setAllowAccessToDashboardList = allowAccessToDashboardList => {
  return {
    type: "SET_ALLOW_ACCESS_DASHBOARD_LIST",
    allowAccessToDashboardList
  };
};

export const setAllowAssociateDashboards = allowAssociateDashboards => {
  return {
    type: "SET_ALLOW_ASSOCIATE_DASHBOARD",
    allowAssociateDashboards
  };
};

export const setAllowAccessToCollaboratorList = allowAccessToCollaboratorList => {
  return {
    type: "SET_ALLOW_ACCESS_COLLABORATOR_LIST",
    allowAccessToCollaboratorList
  };
};

export const setAllowUpdateDashboard = allowUpdateDashboard => {
  return {
    type: "SET_ALLOW_UPDATE_DASHBOARD",
    allowUpdateDashboard
  };
};

export const setAllowUpdateSlide = allowUpdateSlide => {
  return {
    type: "SET_ALLOW_UPDATE_SLIDE",
    allowUpdateSlide
  };
};

export const setAllowCreateSlide = allowCreateSlide => {
  return {
    type: "SET_ALLOW_CREATE_SLIDE",
    allowCreateSlide
  };
};

export const setAllowAccessToSlideList = allowAccessToSlideList => {
  return {
    type: "SET_ALLOW_ACCESS_SLIDE_LIST",
    allowAccessToSlideList
  };
};

export const setAllowAccessToSettings = allowAccessToSettings => {
  return {
    type: "SET_ALLOW_ACCESS_SETTINGS",
    allowAccessToSettings
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/authorizations-settings.js